import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { BagPaymentMethodAddCta } from './BagPaymentMethodAddCta';

// ────────────────────────────────────────────────────────────────────────────

export const BagPaymentMethodGiftCardCta = (props: RedeemGiftCardCtaProps) => {
  const { onPress } = props;
  const { formatMessage } = useIntl();

  return (
    <BagPaymentMethodAddCta
      title={formatMessage(messages.redeemGiftcard)}
      onPress={onPress}
    />
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  redeemGiftcard: {
    defaultMessage: 'Redeem gift card',
    description: 'Bag | Payment method picker | Redeem gift card',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type RedeemGiftCardCtaProps = {
  onPress: () => void;
};
